import { render, staticRenderFns } from "./WithdrawTab.vue?vue&type=template&id=01f276bc"
import script from "./WithdrawTab.vue?vue&type=script&lang=js"
export * from "./WithdrawTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports